module.exports = __webpack_public_path__ + "img/sierra_leone.a64d836.webp";